import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import { signOut } from 'store/auth'
import subjectSlice from 'store/subject'
import { cloudFunctionsInstance } from 'config/axios'

export const initialState = {
  error: null,
  inProgress: false,
  conferences: [],
  conference: null,
  currentPage: 0,
  pageSize: 10
}

const conferenceSlice = createSlice({
  name: 'conference',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setConferences: (state, action) => {
      state.conferences = action.payload
    },
    setConference: (state, action) => {
      state.conference = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.conferences = []
      state.conference = null
      state.currentPage = 0
      state.pageSize = 10
    }
  }
})

export const fetchConference = () => async (dispatch) => {
  try {
    dispatch(conferenceSlice.actions.setProgress(true))
    FirestoreDatabase.collection(Collection.CONFERENCES)
      .orderBy('startDate', 'asc')
      .onSnapshot((documents) => {
        const conferences = []
        documents.forEach((doc) => {
          conferences.push({
            id: doc.id,
            ...doc.data()
          })
        })
        dispatch(conferenceSlice.actions.setConferences(conferences))
        dispatch(conferenceSlice.actions.setProgress(false))
      })
  } catch (err) {
    dispatch(conferenceSlice.actions.setError(err))
    dispatch(conferenceSlice.actions.setProgress(false))
  }
}

export const fetchConferenceById = (conferenceId) => async (dispatch) => {
  try {
    dispatch(conferenceSlice.actions.setProgress(true))
    const snapshot = await FirestoreDatabase.collection(Collection.CONFERENCES)
      .doc(conferenceId)
      .get()
    if (snapshot.exists) {
      const conference = {
        id: snapshot.id,
        ...snapshot.data()
      }
      dispatch(conferenceSlice.actions.setConference(conference))
    }
  } catch (err) {
    dispatch(conferenceSlice.actions.setError(err))
  } finally {
    dispatch(conferenceSlice.actions.setProgress(false))
  }
}

export const updateConferenceById = (id, payload) => async (dispatch, getState) => {
  try {
    const conference = getState().conference.conference
    await FirestoreDatabase.collection(Collection.CONFERENCES).doc(id).update(payload)
    dispatch(conferenceSlice.actions.setConference({ ...conference, ...payload }))
    return true
  } catch (err) {
    dispatch(conferenceSlice.actions.setError(err))
  }
}

export const addConference = (payload) => async (dispatch) => {
  try {
    dispatch(conferenceSlice.actions.setProgress(true))
    const doc = await FirestoreDatabase.collection(Collection.CONFERENCES).add({
      ...payload
    })
    dispatch(conferenceSlice.actions.setProgress(false))
    return doc.id
  } catch (err) {
    dispatch(conferenceSlice.actions.setError(err))
    dispatch(conferenceSlice.actions.setProgress(false))
  }
}

export const resetConferenceStore = () => (dispatch) => {
  dispatch(conferenceSlice.actions.setConference({}))
}

export const deleteConferenceAlongData = (conferenceId) => async (dispatch) => {
  try {
    const response = await cloudFunctionsInstance.delete(
      `/deleteConference?conferenceId=${conferenceId}`
    )
    return response.data
  } catch (err) {
    console.error(err)
    dispatch(subjectSlice.actions.setError(err))
  }
}
export default conferenceSlice
